module.exports = __webpack_public_path__ + "img/master-equipment.ca8ef74c.png";